<div class="editorForm">
  <!-- header Detalle -->
  <div class="row">
    <!-- Cuadro izquierdo -->
    <div class="col-4">
      <!-- Fecha Inicio -->
      <div class="row">
        <app-form-date-edit id="texto-aviso-editor-dataIni" class="col-12" i18n-label label="Data Inici" [isReadOnly]="!this.currentEditing" [(value)]="this.currentTexto.fechaInicio"></app-form-date-edit>
      </div>
      <!-- fecha Fin -->
      <div class="row">
        <app-form-date-edit id="texto-aviso-editor-dataFi" class="col-12" i18n-label label="Data Fi" [isReadOnly]="!this.currentEditing" [(value)]="this.currentTexto.fechaFin"></app-form-date-edit>
      </div>
    </div>
    
    <!-- Cuadro derecho -->
    <div class="col-8">
      <!-- Primera fila -->
      <div class="row">
        <!-- Idioma -->
        <div class="col-3">
          <app-combo-box-input #comboSiglas i18n-label [label]="'Idioma'" [disabled]="!this.currentEditing" [showingOptions]="this.idiomaDictionary" 
                               (optionChanged)="this.siglaSeleccionada($event)" [(value)]="this.currentTexto.idioma">
          </app-combo-box-input>
        </div>
        <!-- Título -->
        <div class="col-9">
          <app-form-text-edit id="texto-aviso-editor-titulo" [isReadOnly]="!this.currentEditing" [(value)]="this.currentTexto.titulo" i18n-label label="Títol"></app-form-text-edit>
        </div>
      </div>
      <!-- Segunda fila (Checkbox Blocks Login) -->
      <div class="row">
        <app-form-check-edit class="col-xl-6" i18n-label label="Bloqueja Log In" [disabled]="!this.currentEditing" 
          [value]="this.currentTexto !== undefined ? !this.currentTexto.permiteLogIn : false" (valueChange)="this.changeLogInBlock($event)">
        </app-form-check-edit>
      </div> 
    </div>
  </div>

  <div class="row">
    <app-html-editor class="col-12" [textoFormatado]="this.currentTexto.htmlValue" (textoFormatadoChanged)="this.textoFormatadoChanged($event)" 
      [isReadOnly]="!this.currentEditing"></app-html-editor>
  </div>
</div>
